import $ from 'jquery';

export default class UsefulInformation {
	constructor() {
		this.usefulInformation = $('.useful-information');
		this.title = $('.useful-information__title');
		this.confirmYes = $('.button-confirm_yes');
		this.confirmNo = $('.button-confirm_no');
		this.feedback = $('.feedback');
	}

	init() {
		this.confirmYes.on('click', event => {
			event.preventDefault();

			this.usefulInformation.addClass('useful-information_success');
			this.title.html('Спасибо за ваш ответ!');
		});

		this.confirmNo.on('click', event => {
			event.preventDefault();

			this.feedback.addClass('feedback_open');
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/useful-information/index.js